<template>
    <div class="text-muted small" aria-live="polite">
        <strong>{{ length.length }} tecken · {{ length.messages }} {{ length.messages === 1 ? 'SMS-del' : 'SMS-delar' }}</strong>
        <div>{{ length.remaining }} tecken kvar i aktuell del</div>
        <b-dropdown size="sm" variant="link" text="Om SMS-längd" no-caret toggle-class="p-0">
            <b-dropdown-text style="min-width: 240px;">
                Kodning: {{ length.encoding }}. Specialtecken och emoji kan ge fler SMS-delar.
                Variablernas längd kan skilja sig mellan exemplet och faktiska mottagare.
            </b-dropdown-text>
        </b-dropdown>
    </div>
</template>

<script>
import { count } from 'sms-length';

export default {
    name: 'SmsSummary',
    props: { text: { type: String, default: '' } },
    computed: {
        length() { return count(this.text); },
    },
};
</script>
